import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import MandatoryServiceSelected from './MandatoryServiceSelected';
import LoadableNumberInput from './loadableComponents/LoadableNumberInput';
import OptionalServiceSelected from './OptionalServiceSelected';
import PriceFormatter from './formatterComponents/PriceFormatter';
import MinimumPriceFormatter from './formatterComponents/MinimumPriceFormatter';
import Tooltip from './Tooltip';
import LoadableStatefulButton from './loadableComponents/LoadableStatefulButton';
import translator from '../translations/drupalTranslator';
import {decodeEntities} from '../api/utils';
import {OPTIONAL} from '../constants/ServicesPaymentTime';

class ExtraService extends Component {
  constructor(props) {
    super(props);
    this.handleResize = throttle(() => this.forceUpdate(),
      100);
  }

  componentDidMount() {
    window.addEventListener('resize',
      this.handleResize,
      false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize',
      this.handleResize,
      false);
  }

  render() {
    const { extraService, hideBorderSecurityServiceGroup, inputChange, salesMarket } = this.props;

    const onChange = (name, value) => {
      const updatedValue = typeof value === 'boolean' ? (value ? 1 : 0) : value; // eslint-disable-line no-nested-ternary
      inputChange(name,
        updatedValue);
    };

    let input;
    let price;
    let moreInfoLink;
    let extraServiceDescription;
    let serviceTooltipDescriptionPrefix = '';

    const isOptional = (
      !extraService.obligatory &&
      extraService.unitPrice.amount &&
      extraService.type === 'OWNER'
    );

    if (extraService.unitPrice.amount !== 0) {
      price = (<PriceFormatter price={extraService.unitPrice} />);
    }

    if (extraService.unitPrice.amount === 0) {
      input = null;
      price = translator.translate('Free');
    }
    else if (extraService.paymentTime === OPTIONAL) {
      let primaryContent = extraService.type === 'NOVASOL' && this.props.rental.isDanishProperty ?
        translator.translate('Pay for service in MyBooking') :
        translator.translate('Pay for service on arrival');

      serviceTooltipDescriptionPrefix = extraService.type === 'NOVASOL' && this.props.rental.isDanishProperty ?
        translator.translate('Make payment now, or we will email you for payment one week before your holiday.') + ' ' : '';
      input = (
        <LoadableStatefulButton
          additionalClassName="deposit-toggle"
          loadingWrapClass="loading-wrap-service-input"
          name={extraService.serviceId}
          onChange={onChange}
          primaryContent={primaryContent}
          secondaryContent={translator.translate('Pay for service now')}
          value={!!extraService.unitCount}
        />
      );
    }
    else if (isOptional) {
      input = <OptionalServiceSelected />;
    }
    else if (extraService.obligatory && extraService.unitPrice.amount !== 0) {
      input = <MandatoryServiceSelected />;
    }
    else if (extraService.maxUnits === 1) {
      input = (
        <LoadableStatefulButton
          additionalClassName="service-toggle"
          loadingWrapClass="loading-wrap-service-input"
          name={extraService.serviceId}
          onChange={onChange}
          primaryContent={translator.translate('Remove')}
          secondaryContent={translator.translate('Add')}
          value={!!extraService.unitCount}
        />
      );
    } else {
      input = (
        <LoadableNumberInput
          loadingWrapClass="loading-wrap-service-input"
          max={extraService.maxUnits}
          name={extraService.serviceId}
          onChange={onChange}
          value={extraService.unitCount}
        />
      );
    }

    if (extraService.moreInfoLink) {
      moreInfoLink = (
        <span className="service__more-info">
          <a href={extraService.moreInfoLink} rel="noopener noreferrer" target="_blank">{translator.translate('Additional information')}</a>
        </span>
      );
    }

    if (extraService.unitPrice.amount && extraService.unitDescription) {
      extraServiceDescription = (
        <span className="service__name-description">
          {decodeEntities(extraService.unitDescription)}
        </span>
      );
    }

    const classes = ['service'];
    if (extraService.obligatory && extraService.serviceId !== '8006') {
      classes.push('service--mandatory');
    }
    else if (isOptional) {
      classes.push('service--optional');
    }

    if (
      extraService.serviceId === '1001' &&
      hideBorderSecurityServiceGroup
    ) {
      classes.push('service--no-border-bottom');
    }

    return (
      <ul className={classes.join(' ')}>
        <li className="service__name">
          {decodeEntities(extraService.name)}
          {extraServiceDescription}
          {extraService.minimumPrice.amount ? (
            <MinimumPriceFormatter
              price={extraService.minimumPrice}
            />
          ) : null}
          {moreInfoLink}
        </li>
        <li className="service__tooltip" key="service__tooltip">
          {extraService.description ? (
            <Tooltip>
              <span dangerouslySetInnerHTML={{__html: serviceTooltipDescriptionPrefix + decodeEntities(extraService.description)}}></span>
            </Tooltip>
          ) : null}
          {/* FRANCE ONLY (250) Mandatory-Cleaning Legal Text */}
          {extraService.serviceId === 'REN' &&
          salesMarket === '250' &&
          extraService.type === 'OWNER' &&
          !extraService.obligatory &&
          !extraService.description &&
          extraService.unitPrice.amount !== 0 && (
            <Tooltip>
              <span>{translator.translate('If you choose to clean the house yourself, please be aware that no or insufficient cleaning, as well as damages may lead to the payment of compensation')}</span>
            </Tooltip>
          )}
        </li>
        <li className="service__price" key="service__price">{price}</li>
        {input ? (
          <li className="service__input">
            {input}
          </li>
        ) : null}
        {isOptional ? (
          <li className="service__message message message--info">
            {translator.translate('Can be ordered after the booking has been confirmed and we have received your payment.')}
          </li>
        ): null
        }
      </ul>
    );
  }
}

ExtraService.PropTypes = {
  extraService:PropTypes.shape({
    description:PropTypes.string.isRequired,
    maxUnits:PropTypes.number.isRequired,
    minimumPrice:PropTypes.object.isRequired,
    moreInfoLink:PropTypes.string,
    name:PropTypes.string.isRequired,
    obligatory:PropTypes.bool.isRequired,
    paymentTime:PropTypes.string.isRequired,
    serviceId:PropTypes.string.isRequired,
    type:PropTypes.string.isRequired,
    unitCount:PropTypes.number.isRequired,
    unitDescription:PropTypes.string,unitPrice: PropTypes.object.isRequired,
  }).isRequired,
  inputChange: PropTypes.func.isRequired,
  hideBorderSecurityServiceGroup: PropTypes.bool,
  salesMarket: PropTypes.string,
};

export default ExtraService;
